/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That content is too long for a QR code — shorten it.`)
};

const es_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese contenido es demasiado largo para un código QR — acórtalo.`)
};

const de_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Inhalt ist zu lang für einen QR-Code — kürze ihn.`)
};

const nl_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die inhoud is te lang voor een QR-code — maak hem korter.`)
};

const fr_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce contenu est trop long pour un QR code — raccourcissez-le.`)
};

const it_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel contenuto è troppo lungo per un codice QR — accorcialo.`)
};

const pt_br2_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse conteúdo é longo demais para um código QR — reduza o texto.`)
};

const pt_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse conteúdo é demasiado longo para um código QR — reduza-o.`)
};

const ja_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容が長すぎてQRコードにできません — 短くしてください。`)
};

const zh_qr_too_long = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容过长，无法生成二维码——请缩短内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_too_long = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_too_long(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_too_long", locale)
	if (locale === "en") return en_qr_too_long(inputs)
	if (locale === "es") return es_qr_too_long(inputs)
	if (locale === "de") return de_qr_too_long(inputs)
	if (locale === "nl") return nl_qr_too_long(inputs)
	if (locale === "fr") return fr_qr_too_long(inputs)
	if (locale === "it") return it_qr_too_long(inputs)
	if (locale === "pt-BR") return pt_br2_qr_too_long(inputs)
	if (locale === "pt") return pt_qr_too_long(inputs)
	if (locale === "ja") return ja_qr_too_long(inputs)
	return zh_qr_too_long(inputs)
};